import React from "react";
import { Field } from "../hrComponents";

export { Field };

// Lays a level's fields out two to a row.
export function FormFieldsLite({ children }) {
  return <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "0 16px" }}>{children}</div>;
}
